import "@fontsource/roboto";
import "@fontsource/ubuntu";

/* no babel so we have to use old js syntax */
window.Popper = require('popper.js');
require('bootstrap');

window.blueimp = require('blueimp-gallery');

$(function() {
    function openAcc() {
        var hash = window.location.hash;
        $(hash).find('h3').click();
    }

    if(window.location.hash) {
        openAcc();
    }

    $(window).on('hashchange', function() {
        openAcc();
    });
});



//////////////////
// WEBPACK FOOTER
// ./js/theme.js
// module id = 2
// module chunks = 0